import React, { createContext, useContext, useState, useEffect } from 'react';
import superAdminApi from '../utils/superAdminApi';

const SuperAdminAuthContext = createContext();

// Parallel to AuthContext.js, deliberately not merged with it — the
// platform-owner Super Admin and a shop's staff login are different
// identities with separate tokens (superadmin_token vs token).
export const SuperAdminAuthProvider = ({ children }) => {
  const [superAdmin, setSuperAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('superadmin_token');
    const stored = localStorage.getItem('superadmin_profile');
    if (token && stored) {
      try { setSuperAdmin(JSON.parse(stored)); } catch { /* ignore corrupt cache */ }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await superAdminApi.post('/auth/login', { email, password });
    const { token, superAdmin: sa } = res.data;
    localStorage.setItem('superadmin_token', token);
    localStorage.setItem('superadmin_profile', JSON.stringify(sa));
    setSuperAdmin(sa);
    return sa;
  };

  const logout = () => {
    localStorage.removeItem('superadmin_token');
    localStorage.removeItem('superadmin_profile');
    setSuperAdmin(null);
  };

  // After editing name / email in "My Account" — keep the cached profile in step.
  const updateProfile = (sa) => {
    localStorage.setItem('superadmin_profile', JSON.stringify(sa));
    setSuperAdmin(sa);
  };

  return (
    <SuperAdminAuthContext.Provider value={{ superAdmin, login, logout, loading, updateProfile }}>
      {children}
    </SuperAdminAuthContext.Provider>
  );
};

export const useSuperAdminAuth = () => useContext(SuperAdminAuthContext);
